import { classes as l } from "../classes/classes.js";
import '../assets/ExpandFullPagePanel.css';const h = "op_popOutHolder_zU0y6", y = "op_popOutHolderTransform_EoRzA", v = "op_contentHolder_ItlDN", w = "op_contentHolderTransform_u-hMq", N = "op_action_3vFVT", O = "op_actionTransform_RtBU1", e = {
  popOutHolder: h,
  popOutHolderTransform: y,
  contentHolder: v,
  contentHolderTransform: w,
  action: N,
  actionTransform: O
}, { useState: E } = wp.element;
function P(d) {
  let {
    open: m = "Edit",
    close: p = "Close",
    href: u = "/",
    children: f,
    notHiddenPre: i,
    notHiddenPost: H,
    popOutHolderAttributes: t = {},
    contentHolderAttributes: n = {},
    linkAttributes: a = {},
    onClose: T = () => {
    }
  } = d;
  const [o, s] = E(!1);
  function _(c) {
    c.preventDefault();
    let r = JSON.parse(c.target.dataset.value);
    if (r) {
      document.body.style.width = document.body.clientWidth + "px", document.body.style.overflow = "hidden", s(r);
      return;
    }
    document.body.style.overflow = null, document.body.style.width = null, T(), s(r);
  }
  return /* @__PURE__ */ React.createElement("div", { ...t, className: l(e.popOutHolder, o ? e.popOutHolderTransform : "", t == null ? void 0 : t.className) }, /* @__PURE__ */ React.createElement("div", { ...n, className: l(e.contentHolder, o ? e.contentHolderTransform : "", n == null ? void 0 : n.className) }, /* @__PURE__ */ React.createElement(
    "a",
    {
      href: u,
      ...a,
      className: l(o ? e.actionTransform : e.action, a == null ? void 0 : a.className),
      "data-value": o != !0,
      onClick: _
    },
    o == !0 ? p : m
  ), i, o ? f : "", H));
}
export {
  P as ExpandFullPagePanel
};
